// @core/api/endpoints/license/issue_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  IssueLicenseRequest,
  LicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Issue new license
 * Issues a new cryptographically signed license (Ed25519) for a customer platform. Sets entitlements, limits, and validity period. Master-only operation.
 */
export async function IssueLicense(
  data: IssueLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses`;
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
